import Vue from "vue";
import axios from "axios";
import Store from "@/store";
import Router from "@/router";

let config = {
  baseURL: process.env.VUE_APP_API_PATH || "http://localhost:8000/api"
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    config.headers.Authorization = "";
    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    }
  });
};

Vue.use(Plugin);

export default Plugin;
